import React, { useEffect, useState } from 'react'
import { createNewsletter } from '../../apis/apiList/userApi';
import { useMessage } from "../../context/MessageContext";

function GetYourFree() {
    const [formData, setFormData] = useState({
      organization_name: "",
      contact_name: "",
      email: "",
      attachment: null,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { showMessage } = useMessage();
    const [errors, setErrors] = useState({});
    const [submitResult, setSubmitResult] = useState("");
  
    const handleChange = (e) => {
      const { name, value, files } = e.target;
  
      if (name === "attachment") {
        setFormData((prev) => ({ ...prev, [name]: files[0] }));
      } else {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    };
  
    const validate = () => {
      let newErrors = {};
  
      if (!formData.organization_name.trim()) {
        newErrors.organization_name = "Organization Name is required";
      }
      if (!formData.contact_name.trim()) {
        newErrors.contact_name = "Contact Name is required";
      }
      if (!formData.email.trim()) {
        newErrors.email = "Email Address is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Email Address is invalid";
      }
      // if (!formData.attachment) {
      //   newErrors.attachment = "Attachment is required";
      // }
  
      setErrors(newErrors);
  
      return Object.keys(newErrors).length === 0;
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      
      if (validate()) {
        setIsSubmitting(true);
        setErrors({});
        try {
          const formDataToSend = new FormData();
          formDataToSend.append("organization_name", formData.organization_name);
          formDataToSend.append("contact_name", formData.contact_name);
          formDataToSend.append("email", formData.email);
          formDataToSend.append("attachment", formData.attachment);

          const newsletterRes = await createNewsletter(formDataToSend, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          // Reset form after submission if needed
          setFormData({
            organization_name: "",
            contact_name: "",
            email: "",
            attachment: null,
          });
          // Remove value_focus class after form reset
          const entries = document.querySelectorAll(".contact-form .entry");
          entries.forEach((entry) => {
            entry.classList.remove("value_focus");
          });

          showMessage("Form submitted successfully!", "success");
        } catch (error) {
          console.error("Error submitting form:", error);
          setSubmitResult("There was an error submitting the form. Please try again.");
        } finally {
          setIsSubmitting(false); // 🔥 Re-enable button always (success or fail)
        }
      } else {
        setSubmitResult("");
      }
    };

    useEffect(() => {
      const inputs = document.querySelectorAll(".contact-form .entry input");

      const handleFocus = (e) => {
        e.target.closest(".entry")?.classList.add("input_focus");
      };

      const handleBlur = (e) => {
        e.target.closest(".entry")?.classList.remove("input_focus");
      };

      const handleInput = (e) => {
        const entry = e.target.closest(".entry");
        if (e.target.value !== "") {
          entry?.classList.add("value_focus");
        } else {
          entry?.classList.remove("value_focus");
        }
      };

      inputs.forEach((input) => {
        input.addEventListener("focus", handleFocus);
        input.addEventListener("blur", handleBlur);
        input.addEventListener("input", handleInput);
      });

      // Cleanup event listeners when component unmounts
      return () => {
        inputs.forEach((input) => {
          input.removeEventListener("focus", handleFocus);
          input.removeEventListener("blur", handleBlur);
          input.removeEventListener("input", handleInput);
        });
      };
    }, []);
  return (
    <>
      <section className="get-your-free" id="">
        <div className="row ">
          <div className="container">
            <div className="title wow zoomIn">
              <h2>
                Get Your Free <span className="red">Snapshot Video</span>
              </h2>
            </div>
            <div className="contact-form wow zoomIn">
              <form
                onSubmit={handleSubmit}
                encType="multipart/form-data"
                >
                <div className={`entry ${errors.organization_name ? "error" : ""}`}>
                    <label>Organization Name<em>*</em></label>
                    <input
                        type="text"
                        id="organization_name"
                        name="organization_name"
                        value={formData.organization_name? formData.organization_name : ""}
                        onChange={handleChange}
                        style={errors.organization_name ? { border: "1px solid #ff0000" } : {}}
                    />
                    {errors.organization_name && <div className="mage-error">{errors.organization_name}</div>}
                </div>

                <div className={`entry ${errors.contact_name ? "error" : ""}`}>
                    <label>Contact Name<em>*</em></label>
                    <input
                        type="text"
                        id="contact_name"
                        name="contact_name"
                        value={formData.contact_name ? formData.contact_name : ""}
                        onChange={handleChange}
                        style={errors.contact_name ? { border: "1px solid #ff0000" } : {}}
                    />
                    {errors.contact_name && <div className="mage-error">{errors.contact_name}</div>}
                </div>

                <div className={`entry mail ${errors.email ? "error" : ""}`}>
                    <label>Email Address<em>*</em></label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email ? formData.email : ""}
                        onChange={handleChange}
                        style={errors.email ? { border: "1px solid #ff0000" } : {}}
                    />
                    {errors.email && <div className="mage-error">{errors.email}</div>}
                </div>

                <div className={`entry upload ${errors.attachment ? "error" : ""}`}>
                    <label>Upload a Newsletter<em>*</em></label>
                    <input
                        className="upload"
                        type="file"
                        id="newsletter"
                        name="attachment"
                        onChange={handleChange}
                        // value={formData.attachment ? formData.attachment.name : ""}
                        style={errors.attachment ? { border: "1px solid #ff0000" } : {}}
                    />
                    {errors.attachment && <div className="mage-error">{errors.attachment}</div>}
                </div>

                <p className="newsletter">
                    or email the newsletter to &nbsp;
                    <a href="mailto:darcy@associationstudios.com"> darcy@associationstudios.com</a>.
                </p>

                <div className="submit-btns">
                    <p>
                    <input type="submit" value={isSubmitting ? "Submitting..." : "Submit"}
                      disabled={isSubmitting}
                      className="submit csubmit-btn1 f-submit"
                      style={isSubmitting ? { padding: '0px 52px 0px 22px' } : {}}
                    />
                    </p>
                </div>

                <div className="message">
                    {/* {submitResult && <div className="result">{submitResult}</div>} */}
                    {Object.keys(errors).length > 0 && !submitResult && (
                    <div className="error" id="error-msg">
                        One or more fields have an error. Please check and try again.
                    </div>
                    )}
                </div>
                </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default GetYourFree